import { render, staticRenderFns } from "./BroadcastStatistik.vue?vue&type=template&id=c5b6893e"
import script from "./BroadcastStatistik.vue?vue&type=script&lang=js"
export * from "./BroadcastStatistik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports